// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import "trix"

document.addEventListener("trix-file-accept", (event) => {
  // Broadcast emails do not support embedded file uploads.
  event.preventDefault()
})
